import { Switch, useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { useFormStateContext } from '../../../providers/FormStateContext'

interface Props {
  name: string
}

export function StatusToggle(props: Props) {
  const { name } = props
  const { formatMessage } = useIntl()
  const { form, readOnly } = useFormStateContext()

  const status: boolean = useWatch({ form, name })

  return (
    <Switch
      name={name}
      // @ts-ignore: typings conflict for state prop between @vtex/admin-ui and @vtex/admin-ui-form
      state={form}
      disabled={readOnly}
      aria-label={formatMessage({
        id: 'admin/promotions.form.general.status.label',
      })}
      label={formatMessage(
        { id: 'admin/promotions.form.general.status' },
        { status }
      )}
    />
  )
}
